class RelatedProductsCarousel extends HTMLElement {
  constructor() {
    super();
    this.container = null;
    this.carousel = null;
    this.track = null;
    this.progressBar = null;
    this.slickSettings = null;
    this.slidesToShow = 1;
    this.observer = null;
  }

  connectedCallback() {
    setTimeout(() => {
      this.init();
    }, 3000);

    this.setupArrowNavigation();
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
    window.removeEventListener('resize', this.handleResize);
  }

  setupArrowNavigation() {
    const nextArrow = this.querySelector('.arrow-next');
    const prevArrow = this.querySelector('.arrow-prev');

    nextArrow?.addEventListener('click', () => {
      this.querySelector('.slick-next')?.click();
    });

    prevArrow?.addEventListener('click', () => {
      this.querySelector('.slick-prev')?.click();
    });
  }

  init() {
    this.container = this.querySelector('.related-product-container-487');
    this.carousel = this.container?.querySelector('.carousel');
    this.track = this.carousel?.querySelector('.slick-track');
    this.progressBar = this.container?.querySelector('.carousel-progress-bar');

    if (!this.carousel || !this.track || !this.progressBar) {
      return;
    }

    this.parseSlickSettings();
    this.updateSlidesToShow();
    this.setupEventListeners();
    this.setupMutationObserver();
    this.updateProgress();
  }

  parseSlickSettings() {
    try {
      this.slickSettings = JSON.parse(
        this.carousel.dataset.slick.replace(/&quot;/g, '"')
      );
      this.slidesToShow = this.slickSettings.slidesToShow || 1;
    } catch (err) {
      console.error('Failed to parse data-slick:', err);
    }
  }

  updateSlidesToShow() {
    const width = window.innerWidth;
    this.slidesToShow = this.slickSettings?.slidesToShow || 1;

    if (this.slickSettings?.responsive) {
      for (const bp of this.slickSettings.responsive) {
        if (width <= bp.breakpoint && bp.settings?.slidesToShow) {
          this.slidesToShow = bp.settings.slidesToShow;
        }
      }
    }
  }

  updateProgress() {
    if (!this.track || !this.progressBar) return;

    const slides = this.track.querySelectorAll('.slick-slide:not(.slick-cloned)');
    const activeSlides = this.track.querySelectorAll(
      '.slick-slide.slick-active:not(.slick-cloned)'
    );

    if (activeSlides.length === 0) return;

    const total = slides.length;
    const visibleCount = Math.min(this.slidesToShow, total);
    const firstActiveIndex = [...slides].indexOf(activeSlides[0]);

    const thumbWidthPercent = (visibleCount / total) * 100;
    this.progressBar.style.width = `${thumbWidthPercent}%`;

    const maxScrollableIndex = total - 1;
    const scrollPercent =
      maxScrollableIndex > 0 ? firstActiveIndex / maxScrollableIndex : 0;
    const translateXPercent = scrollPercent * (100 - thumbWidthPercent);
    this.progressBar.style.left = `${translateXPercent}%`;
  }

  handleResize = () => {
    this.updateSlidesToShow();
    this.updateProgress();
  };

  setupEventListeners() {
    window.addEventListener('resize', this.handleResize);
  }

  setupMutationObserver() {
    this.observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (
          mutation.type === 'attributes' &&
          mutation.target.classList.contains('slick-slide')
        ) {
          this.updateProgress();
          break;
        }
      }
    });

    this.observer.observe(this.track, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true,
    });
  }
}

if (!customElements.get('related-products-carousel')) {
  customElements.define('related-products-carousel', RelatedProductsCarousel);
}


class ProductCard487 extends HTMLElement {
  constructor() {
    super()
    this.hoverImg = null
    this.hoverImg2 = null
    this.leftZone = null
    this.rightZone = null
    this.boundHandlers = new Map() // Track bound handlers
    this.isInitialized = false // Prevent multiple initializations
  }

  connectedCallback() {
    // Prevent multiple initializations
    if (this.isInitialized) return;
    this.isInitialized = true;

    this.setupHoverEvents()
    this.updateCurrency()
    this.checkReviews()
    this.setupSizeBarEvents()
  }

  disconnectedCallback() {
    // Clean up event listeners when component is removed
    this.boundHandlers.forEach((handler, button) => {
      button.removeEventListener('click', handler);
    });
    this.boundHandlers.clear();
    this.isInitialized = false;
  }

  setupHoverEvents() {
    this.hoverImg = this.querySelector('.hover-image')
    this.hoverImg2 = this.querySelector('.hover-image-2')
    this.leftZone = this.querySelector('.hover-zone.left')
    this.rightZone = this.querySelector('.hover-zone.right')

    if (!this.hoverImg || !this.leftZone || !this.rightZone) return

    const showLeftImage = () => {
      this.hoverImg.style.opacity = '1'
      if (this.hoverImg2) this.hoverImg2.style.opacity = '0'
    }

    const showRightImage = () => {
      if (this.hoverImg2) {
        this.hoverImg.style.opacity = '0'
        this.hoverImg2.style.opacity = '1'
      } else {
        this.hoverImg.style.opacity = '1'
      }
    }

    const hideAll = () => {
      this.hoverImg.style.opacity = '0'
      if (this.hoverImg2) this.hoverImg2.style.opacity = '0'
    }

    this.leftZone.addEventListener('mouseenter', showLeftImage)
    this.rightZone.addEventListener('mouseenter', showRightImage)
    this.leftZone.addEventListener('mouseleave', hideAll)
    this.rightZone.addEventListener('mouseleave', hideAll)

    this.leftZone.addEventListener('touchstart', showLeftImage, { passive: true })
    this.rightZone.addEventListener('touchstart', showRightImage, { passive: true })

    this.leftZone.addEventListener('touchend', hideAll, { passive: true })
    this.rightZone.addEventListener('touchend', hideAll, { passive: true })
  }

  updateCurrency() {
    const currency = document.querySelector(".site-currency")?.innerText.trim();
    const el = this.querySelector('.prod-currency');
    const priceEl = this.querySelector('.prod-price .money');

    if(priceEl){
      let text = priceEl.innerText.replace(/\s[A-Z]{3}$/, '').trim();
      
      text = text.replace(/\s+/g, '');

      priceEl.innerText = `${text}`;
    }

    if (el) {
      el.innerText = `${currency}`;
    }
  }

  checkReviews() {
    // Your review logic here
  }

  setupSizeBarEvents() {
    const sizeButtons = this.querySelectorAll('.size-option.available[data-variant-id]:not([data-variant-id=""])');
    
    // Track pending requests to prevent duplicates
    const pendingRequests = new Set();

    sizeButtons.forEach(btn => {
      // Skip if already has handler
      if (this.boundHandlers.has(btn)) {
        return;
      }

      // Create and store the handler
      const handler = (e) => {
        e.preventDefault();
        e.stopPropagation(); // Prevent event bubbling
        
        const variantId = btn.dataset.variantId;
        if (!variantId) return;
        
        // Prevent duplicate requests
        if (pendingRequests.has(variantId) || btn.classList.contains('loading')) {
          console.log('Request already pending for variant', variantId);
          return;
        }

        btn.classList.add('loading');
        pendingRequests.add(variantId);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(res => {
            if (!res.ok) {
              throw new Error(`HTTP error! status: ${res.status}`);
            }
            return res.json();
          })
          .then(data => {
            console.log(`Variant ${variantId} added to cart`);
            // Trigger cart update event
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
          })
          .catch(err => {
            console.error('Add to cart error:', err);
          })
          .finally(() => {
            btn.classList.remove('loading');
            pendingRequests.delete(variantId);
          });
      };

      // Store the handler reference
      this.boundHandlers.set(btn, handler);
      
      // Add event listener with the stored handler
      btn.addEventListener('click', handler);
    });
  }
}

customElements.define('product-card-487', ProductCard487)
